class SeoHelper {
    /**
     * 获取每个页面的seo数据
     * @param vue 页面组件
     * @param pageName 页面名字，对应langv4的key比如home
     * @param data 页面传进来的数据，不同的页面的数据不一样 产品列表是dataAll所有的数据
     */
    static getRichSnippetComplement(vue, pageName, data) {
        let langPage = vue.$store.state.langPage;
        let lang = vue.$store.state.lang;
        if (!pageName) return {};
        let title = langPage[pageName]['TXT_seotitleheader'];
        let keyword = langPage[pageName]['TXT_seokeyword'];
        let description = langPage[pageName]['TXT_seodescription'];
        let metaInfo = {
            meta: [
                getMetaItem('title', title ? title : ''),
                getMetaItem('keyword', keyword ? keyword : ''),
            ]
        };
        if (!['produits'].includes(pageName)) {
            metaInfo.meta.push(getMetaItem('description', description ? description : ''));
        }
        let infoProduit;
        switch (pageName) {
            case 'home':
                metaInfo.meta.push(getMetaItem('location', 'Bâtiment 211 - Parc Icade Les Portes de Paris, Rue du Grain, 93300 Aubervilliers'));
                metaInfo.meta.push(getMetaItem('telephone', '01 53 27 91 08'));
                metaInfo.meta.push(getMetaItem('openingHours', ["Mo-Fr 09:30-12:30", "Mo-Fr 14:00-18:00"]));
                break;
            case 'produits':
                infoProduit = getInfoProduit(data);
                metaInfo.meta.push(getMetaItem('brand', JSON.stringify({
                    "@type": "Thing",
                    "name": infoProduit.marque
                })));
                metaInfo.meta.push(getMetaItem('description', JSON.stringify({
                    "@type": "Thing",
                    "name": infoProduit.description
                })));
                metaInfo.meta.push(getMetaItem('category', JSON.stringify({
                    "@type": "Thing",
                    "name": infoProduit.category
                })));
                metaInfo.meta.push(getMetaItem('color', infoProduit.couleur));
                break;
        }
        console.log('seoMeta', metaInfo)
        return metaInfo;

        function getMetaItem(name, content) {
            return {
                vmid: name,
                name: name,
                content: content,
            };
        }

        function getInfoProduit(data) {
            let marque = data.produits[0].vendeurs_marque.nom_marque;
            let categoryName = data.produits[0].category.categories_langues[0].libelle;
            let colors = data.produits[0].couleurs.map(color => {
                return color.couleur_FR;
            }).join(',');
            let numColors = data.produits[0].couleurs.length;
            let caracteristique = data.produits[0].caracteristiques[0].caracteristiques_langues[0].libelle;
            let description = '';
            switch (vue.$store.state.lang) {
                case "fr":
                    description = `La marque ${marque} propose ce ${categoryName} ${caracteristique} dans ${numColors} couleurs.`;
                    break;
                case "en":
                    description = `The brand ${marque} proposes this ${categoryName} ${caracteristique} in ${numColors} colors.`;
                    break;
                case "es":
                    description = `La marca ${marque} propone este/a ${categoryName} ${caracteristique} en ${numColors} coulores.`;
                    break;
                case "it":
                    description = `Il marchio ${marque} propone questo/a ${categoryName} ${caracteristique} in ${numColors} colori.`;
                    break;
            }
            return {
                marque: marque,
                category: categoryName,
                couleur: colors,
                description: description,
            }
        }
    }
}

module.exports = SeoHelper;